import React from 'react';
import {Link} from 'react-router-dom'
import {MasterLayout} from 'components/layouts';
import title from 'constants/TitlePages.js';

class PageNotFound extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {

    }
  }
  componentDidMount() {
    document.title = title.PageNotFound;
  }

  render() {
    return (
      <MasterLayout>
        <div className='center'>
          <section className='page-not-found'>
            <h2 className='page-not-found-title'>404</h2>
            <p className='page-not-found-desc'>Nội dung bạn tìm kiếm không tồn tại</p>
            <Link to='/' className='page-not-found-link'>Quay lại Trang chủ</Link>
          </section>
        </div>
      </MasterLayout>
    );
  }
}

export default PageNotFound;


// WEBPACK FOOTER //
// ./pages/PageNotFound.jsx